import styled from 'styled-components/macro';
import { deviceMin } from 'utils/styles/breakpoints';

export const Section = styled.section`
  .about {
    @media ${deviceMin.mobileS} {
      height: 1220px;
    }
    @media (min-width: 340px) {
      height: 1180px;
    }
    @media (min-width: 380px) {
      height: 1120px;
    }
    @media (min-width: 420px) {
      height: 1100px;
    }
    @media (min-width: 590px) {
      height: 1000px;
    }
    @media (min-width: 767px) {
      height: 1000px;
    }
   @media ${deviceMin.desktop} {
      height: 1468px;
    }
  }
  .section {
    @media ${deviceMin.mobileS} {
      height: 1000px;
    }
    @media (min-width: 375px) {
      height: 900px;
    }
    @media ${deviceMin.desktop} {
      height: 1468px;
    }
  }
`;
